import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Fetcher } from "../../components/Fetcher";
import { getOperationalConfiguration } from "../../services/api/operationalConfiguration.api";
import { OperationalConfigurationDetails } from "../../components/OperationalConfigurations/OperationalConfigurationDetails";
import { OperationalConfigurationEdit } from "../../components/OperationalConfigurations/OperationalConfigurationEdit";
import { OperationalConfigurationOverrides } from "../../components/OperationalConfigurations/OperationalConfigurationOverrides";
import { hasPowFeature, POW_FEATURES } from "../../services/powFeatures.service";
import { useForceUpdate } from "../../utils/hooks";

interface OperationalConfigurationDetailPageProps {
	// operational configuration id to fetch details
	operationalConfigurationId: string;
	// product id
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	wrapper: {
		marginBottom: theme.spacing(4),
		maxWidth: 1024,
	},
	title: {
		marginBottom: theme.spacing(4),
	},
	divider: {
		marginTop: 32,
		marginBottom: 24,
	},
}));

/**
 * Page to display operational configuration details and allow configuration editing
 * @param props
 */
export const OperationalConfigurationDetailsPage = (props: OperationalConfigurationDetailPageProps) => {
	const classes = useStyles();
	const forceUpdate = useForceUpdate();

	return (
		<div className={classes.wrapper} data-testid="operational-configuration-details-page">
			<Typography className={classes.title} variant="h4">
				Operational Configuration Details
			</Typography>
			<Fetcher action={getOperationalConfiguration(props.productId, props.operationalConfigurationId)}>
				{({ data }) => (
					<>
						{hasPowFeature(POW_FEATURES.paConfigurations_Admin) ? (
							<OperationalConfigurationEdit
								operationalConfiguration={data}
								productId={props.productId}
								onSuccess={forceUpdate}
							/>
						) : (
							<OperationalConfigurationDetails operationalConfiguration={data} />
						)}
						<Divider className={classes.divider} />
						<OperationalConfigurationOverrides
							productId={props.productId}
							operationalConfigurationId={props.operationalConfigurationId}
							onSuccess={forceUpdate}
							operationalConfigurationOverrides={data.overrides}
						/>
					</>
				)}
			</Fetcher>
		</div>
	);
};
